import React, { Component } from 'react';
import { connect } from 'react-redux';
import Create from '../create/createHook';
import { Navigation, Loader, Snackbar } from 'common';
import {
  Grid,
  Box,
  Typography,
  Divider,
  Button,
  IconButton,
} from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import Anchor from 'antd/es/anchor';
import { editJob, getJobById, deleteJobs } from 'controllers/job';
import '../create/create.scss';
import { validateJobForm } from 'utils/job';
import { JOB_DISPLAY_TYPE } from 'utils/constants';

const { Link } = Anchor;

class EditJobContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    const {
      match: {
        params: { id },
      },
      location: { hash },
      selectedJob,
    } = this.props;

    if ((id && !hash) || (hash && id && !(selectedJob.jobId === id))) {
      this.fetchJob(id);
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  fetchJob = async (id) => {
    await getJobById(id);
    this.setState({
      loading: false,
    });
  };

  validateFields = () => {
    return validateJobForm(this.props.selectedJob);
  };

  onEditJob = async () => {
    const validation = this.validateFields();
    if (!validation) {
      return false;
    }

    this.setState({
      loading: true,
    });
    await editJob();
    this.setState({
      loading: false,
    });
    this.goToJobDescription();
  };

  onDelete = async () => {
    const {
      match: {
        params: { id },
      },
      history,
    } = this.props;
    this.setState({
      loading: true,
    });
    await deleteJobs([id]);
    this.setState({
      loading: false,
    });
    history.push('/screened-pipe');
  };

  onCancel = () => {
    this.goToJobDescription();
  };

  goToJobDescription = () => {
    const {
      match: {
        params: { id },
      },
      history,
    } = this.props;

    history.push(`/job/${id}`);
  };

  render() {
    const { companyDetails, errorFlag, selectedJob } = this.props;
    const { loading } = this.state;

    if (loading) {
      return <Loader />;
    }

    return (
      <div className="create-wrapper">
        <Navigation />
        <div className="create-job">
          <Grid container spacing={3} className="wrapper" justify="center">
            <Grid item xs={12}>
              <Box p="14px 18px 9.5px 18px" display="flex" alignItems="center">
                <Typography variant="h5">Job details</Typography>
                <Box textAlign="right" flexGrow={1}>
                  <IconButton onClick={this.onDelete}>
                    <Delete />
                  </IconButton>
                  <Button
                    variant="outlined"
                    className="create-job-cancel-btn"
                    onClick={this.onCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onEditJob}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={3} justify="flex-start">
                <Grid item xs={2}>
                  <Anchor>
                    <Link href="#the-job" title="The Job" />
                    <Link href="#qualification" title="Qualification" />
                    <Link href="#budget" title="Budget" />
                    <Link href="#about-company" title="About company" />
                  </Anchor>
                </Grid>
                <Create
                  companyDetails={companyDetails}
                  gridWidth={6}
                  displayType={JOB_DISPLAY_TYPE.EDIT}
                  selectedJob={selectedJob}
                  errorFlag={errorFlag}
                />
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Snackbar
          open={errorFlag}
          autoCloseSnackbar={false}
          message={'Please fill required.'}
          type="error"
          flag="error"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  companyDetails: state.user.details.organizationInfo,
  errorFlag: state.flags.error,
  selectedJob: state.job.selectedJob,
});

export default connect(mapStateToProps, null)(EditJobContainer);
